export const AUTH_DATA = {
    ADMIN_ROLES: ["superadmin", "admin"],
    EDITOR: ["editor"],
    SPONSOR: ["sponsor"],
    DOCTOR: ["doctor"],
    CALL_CENTER: ["callcenter"],
    PATIENT: ["patient"],
    GUARDIAN: ["guardian"],
    WITHOUT_ROLE: [null],
};
